import axios from 'axios';

import type {
  ApproveAttachmentsRequestParamsDTO,
  GetAttachmentFromSignedUrlResponseDTO,
  GetAttachmentResponseDTO,
  GetAttachmentUrlResponseDTO,
} from 'declarations/dto/attachments';
import type { AttachmentTypeI } from 'declarations/interfaces/attachments';

import { get, post, remove } from './api';

export const getAttachmentApi = async (
  ticketId: string,
  fileName: string
): Promise<GetAttachmentResponseDTO> => {
  const response = await get<string>(`/attachment/${ticketId}/${fileName}`, undefined, {
    responseType: 'blob',
  });

  return { data: response.data, contentType: response.headers['content-type'] ?? '' };
};

export const getViewAttachmentApi = async (
  ticketId: string,
  fileName: string
): Promise<GetAttachmentResponseDTO> => {
  const response = await get<string>(`/attachment/view/${ticketId}/${fileName}`, undefined, {
    responseType: 'blob',
  });

  return { data: response.data, contentType: response.headers['content-type'] ?? '' };
};

export const deleteAttachmentApi = async (
  ticketId: string,
  fileName: string,
  originalName: string
): Promise<void> => {
  const response = await remove<void>(`/attachment/${ticketId}/${fileName}`, {
    params: { OriginalName: originalName },
  });

  return response.data;
};

export const approveAttachmentsApi = async (
  data: ApproveAttachmentsRequestParamsDTO
): Promise<void> => {
  const dataArr = data.fileNames;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Axios post accepts arrays directly
  const response = await post<void>(`/attachment/approve/${data.ticketId}`, dataArr as any);
  return response.data;
};

export const getAttachmentUrlApi = async (
  ticketId: string,
  fileName: string
): Promise<GetAttachmentUrlResponseDTO> => {
  const response = await get<GetAttachmentUrlResponseDTO>(
    `/attachment/url/${ticketId}/${fileName}`
  );

  return response.data;
};

export const getAttachmentFromSignedUrlApi = async (
  ticketId: string,
  fileName: string
): Promise<GetAttachmentFromSignedUrlResponseDTO> => {
  const signedUrl = await getAttachmentUrlApi(ticketId, fileName);

  // Need to use axios without any authorization
  const axiosWithoutAuth = axios.create({
    baseURL: signedUrl.value,
  });

  const response = await axiosWithoutAuth.get<string>(signedUrl.value, {
    responseType: 'blob',
  });

  return { data: response.data, contentType: response.headers['content-type'] ?? '' };
};

export const getAttachmentTypesApi = async (): Promise<AttachmentTypeI[]> => {
  const response = await get<AttachmentTypeI[]>('/attachment/types');

  return response.data;
};
